export default __webpack_public_path__ + "static/media/polymerisationslampe.0f873836.png";